<template>
  <div class="modal fade" id="modal-filter" role="dialog" data-backdrop="static">
    <div class="modal-dialog modal-lg bani-modal h-100">
      <div class="modal-content w-limit vh-100" style="border-radius: 0">
        <div class="modal-header">
          <div class="nav-btn kiri tutup">
            <img src="../../../../assets/img/x2.svg" @click="back" alt="">
          </div>
          <h5 class="navbar-title text-center">Filter</h5>
          <div class="nav-btn kanan">
          </div>
        </div>

        <div class="content-wrapper">
          <div class="vh-100">
            <SOFilterOutletNonaktif
                :id="'filter-outlet-nonaktif'"
                v-if="filterSetting.outletNonaktif"
            />
            <SOFilterWorkshopNonaktif
                :id="'filter-workshop-nonaktif'"
                v-if="filterSetting.workshopNonaktif"
            />

            <SOFilterPaketKedaluarsa
                :id="'filter-paket-kedaluarsa'"
                v-if="filterSetting.paketKedaluarsa"
            />

            <SOFilterSortingV2
                :id="'filter-sorting'"
                :sorting="sorting"
                v-if="filterSetting.sorting.show"
            />
            <SOFilterJenisKonsumen
                :id="'filter-jenis-konsumen'"
                v-if="filterSetting.jenisKonsumen"
            />
            <SOFilterPeriode
                :id="'filter-periode'"
                :title="customTitle.periode"
                :periode-transaksi="jensiPeriode.transaksi"
                :option-data="optionData.periode.data"
                v-model="optionData.periode.selected"
                :filter-global-key="optionData.periode.filterGlobalKey"
                v-bind:keterangan="keteranganPeriode"
                v-if="filterSetting.periode"
            />
            <SOFilterAgama
                :id="'filter-agama'"
                v-if="filterSetting.agama"
            />
            <SOFilterStatusOutlet
                :id="'filter-status-outled'"
                v-if="filterSetting.statusOutlet"
            />
            <SOFilterKota
                :id="'filter-kota'"
                v-if="filterSetting.kota"
            />
            <SOFilterJenisLayananReguler
                :id="'filter-jenis-layanan-reguler'"
                :title="customTitle.jenisLayananReguler"
                v-if="filterSetting.jenisLayananReguler"
            />
            <SOFilterStatusKonfirmasi
                ref="filterStatusKonfirmasi"
                :id="'filter-status-konfirmasi'"
                :title="customTitle.statusKonfirmasi"
                v-if="filterSetting.statusKonfirmasi"
            />
            <SOFilterAkunKeuanganGlobal
                :id="'filter-akun-keuangan-global'"
                :title="customTitle.akunKeuanganGlobal"
                v-if="filterSetting.akunKeuanganGlobal"
            />
            <SOFilterAkunBiayaItemBiaya
                :id="'filter-akun-biaya-item-biaya'"
                :title="customTitle.akunBiayaItemBiaya"
                v-if="filterSetting.akunBiayaItemBiaya"
            />
            <SOFilterJenisTransaksi
                :id="'filter-jenis-transaksi'"
                v-if="filterSetting.jenisTransaksi"
            />
            <SOFilterTipePembayaran
                :id="'filter-tipe-transaksi'"
                v-if="filterSetting.tipePembayaran"
            />
            <SOFilterJenisPembayaran
                :id="'filter-jenis-pembayaran'"
                v-if="filterSetting.jenisPembayaran"
            />
            <SOFilterJenisPembayaranSnapclean
                :id="'filter-jenis-pembayaran-snapclean'"
                v-if="filterSetting.jenisPembayaranSnapclean"
            />
            <SOFilterStatusMesinEdc
                :id="'filter-status-mesin-edc'"
                v-if="filterSetting.statusMesinEdc"
            />
            <SOFilterProviderEdc
                :id="'filter-provider-edc'"
                :title="customTitle.providerEdc"
                v-if="filterSetting.providerEdc"
            />
            <SOFilterSettlementAkun
                :id="'filter-akun-settlement'"
                :title="customTitle.akunSettlement"
                :use-check-all="checkAll.akunSettlement"
                v-if="filterSetting.akunSettlement"
            />
            <SOFilterOutlet
                :id="'filter-outlet'"
                :title="customTitle.outlet"
                :use-check-all="checkAll.outlet"
                v-if="filterSetting.outlet"
            />
            <SOFilterWorkshop
                :id="'filter-workshop'"
                :title="customTitle.workshop"
                :use-check-all="checkAll.workshop"
                v-if="filterSetting.workshop"
            />
            <SOFilterLayananOwner
                :id="'filter-layanan-owner'"
                :with-option="optionData.layananOwner.data.length > 0"
                :option-data="optionData.layananOwner.data"
                :option-selected="optionData.layananOwner.selected"
                :title="customTitle.layananOwner"
                v-if="filterSetting.layananOwner"
            />
            <SOFilterLayananSnapcleanOwner
                :id="'filter-layanan-snapclean-owner'"
                :with-option="optionData.layananSnapcleanOwner.data.length > 0"
                :option-data="optionData.layananSnapcleanOwner.data"
                :option-selected="optionData.layananSnapcleanOwner.selected"
                v-if="filterSetting.layananSnapcleanOwner"
            />
            <SOFilterPaketDeposit
                :id="'filter-paket-deposit'"
                :title="customTitle.paketDeposit"
                :use-check-all="checkAll.deposit"
                v-if="filterSetting.deposit"
            />
            <SOFilterStatusDeposit
                :id="'filter-status-deposit'"
                v-if="filterSetting.statusDeposit"
            />
            <SOFilterPaketEpayment
                :id="'filter-paket-epayment'"
                :title="customTitle.paketEpayment"
                :use-check-all="checkAll.epayment"
                v-if="filterSetting.epayment"
            />
            <SOFilterStatusLayanan
                :id="'filter-status-layanan'"
                v-if="filterSetting.statusLayanan"
            />
            <SOFilterDataKonsumen
                :id="'filter-data-konsumen'"
                :title="customTitle.dataKonsumen"
                v-if="filterSetting.dataKonsumen"
            />
            <SOFilterJenisLayananSnapclean
                :id="'filter-jenis-layanan-snapclean'"
                :title="customTitle.jenisLayananSnapclean"
                v-if="filterSetting.jenisLayananSnapclean"
            />
            <SOFilterJenisMesinSnapclean
                :id="'filter-jenis-mesin-snapclean'"
                v-if="filterSetting.jenisMesinSnapclean"
            />
            <SOFilterSatuan
                :id="'filter-satuan'"
                v-if="filterSetting.satuan"
            />
            <SOFilterKategoriLayanan
                :id="'filter-kategori-layanan'"
                v-if="filterSetting.kategoriLayanan"
            />
            <SOFilterKategoriMesin
                :id="'filter-kategori-mesin'"
                v-if="filterSetting.kategoriMesin"
            />
            <SOFilterKategoriRak
                :id="'filter-kategori-rak'"
                v-if="filterSetting.kategoriRak"
            />
            <SOFilterLayananTerhubung
                :id="'filter-layanan-terhubung'"
                :idcustomer="idcustomer"
                v-if="filterSetting.layananTerhubung"
            />
            <SOFilterMasaAktif
                :id="'filter-masa-aktif'"
                v-if="filterSetting.masaAktif"
            />
            <SOFilterBonusEpayment
                :id="'filter-bonus-epayment'"
                v-if="filterSetting.bonusEpayment"
            />
            <SOFilterStatusWorkshop
                :id="'filter-status-workshop'"
                v-if="filterSetting.statusWorkshop"
            />
            <SOFilterStatusKaryawan
                :id="'filter-status-karyawan'"
                v-if="filterSetting.statusKaryawan"
            />
            <SOFilterStatusAbsen
                :id="'filter-status-absen'"
                v-if="filterSetting.statusAbsen"
            />
            <SOFilterSumberAbsen
                :id="'filter-sumber-absen'"
                v-if="filterSetting.sumberAbsen"
            />
            <SOFilterStatusGaji
                :id="'filter-status-gaji'"
                v-if="filterSetting.statusGaji"
            />
            <SOFilterStatusTanggungan
                :id="'filter-status-tanggungan'"
                v-if="filterSetting.statusGaji"
            />
            <SOFilterStatusPembayaran
                :id="'filter-status-pembayaran'"
                v-if="filterSetting.statusPembayaran"
            />
            <SOFilterStatusTransaksi
                :id="'filter-status-transaksi'"
                v-if="filterSetting.statusTransaksi"
            />
            <SOFilterStatusTransaksiSnapclean
                :id="'filter-status-transaksi-snapclean'"
                v-if="filterSetting.statusTransaksiSnapclean"
            />
            <SOFilterNotaDihitung
                :id="'filter-nota-dihitung'"
                v-if="filterSetting.notaDihitung"
            />
            <SOFilterKontakKonsumen
                :id="'filter-kontak-konsumen'"
                v-if="filterSetting.kontakKonsumen"
            />
            <SOFilterSaldoEPayment
                :id="'filter-saldo-epayment'"
                v-if="filterSetting.filterSaldoEpayment"
            />
            <SOFilterSnapConsole
                :id="'filter-jenis-console'"
                v-if="filterSetting.jenisSnapConsole"
            />
            <SOFilterJenisMesin
                :id="'filter-jenis-mesin'"
                v-if="filterSetting.jenisMesin"
            />
            <SOFilterStatusKoneksi
                :id="'filter-status-koneksi'"
                v-if="filterSetting.statusKoneksi"
            />
            <SOFilterStatuspMesin
                :id="'filter-status-mesin'"
                v-if="filterSetting.statusMesin"
            />
            <SOFilterStatusSensorPintu
                :id="'filter-status-sensor-pintu'"
                v-if="filterSetting.statusSensorPintu"
            />
            <SOFilterKaryawan
                :id="'filter-karyawan'"
                :title="customTitle.karyawan"
                v-if="filterSetting.karyawan"
            />
            <SOFilterMetodeTopup
                :id="'filter-metode-top-up'"
                v-if="filterSetting.metodeTopup"
            />
            <SOFilterMesinSnap
                :id="'filter-mesin-snap'"
                :title="customTitle.mesinSnap"
                v-if="filterSetting.mesinSnap"
            />
            <SOFilterOwner
                :id="'filter-owner-afiiliated'"
                :jenis-owner="ownerAfiliated"
                v-if="filterSetting.afiliasiOwner"
            />
            <SOFilterRekeningAtasNama
                :id="'filter-rekening-atas-nama'"
                :use-check-all="false"
                :title="'Rekening Atas Nama'"
                v-if="filterSetting.rekeningAtasNama"
            />
            <SOFilterJenisTransaksiRiwayatTransfer
                :id="'filter-jenis-layanan-reguler'"
                :title="'Jenis Transaksi'"
                v-if="filterSetting.jenisTransaksiRiwayatTransfer"
            />
            <SOFilterTanggalTransfer
                :id="'filter-tanggal-transfer'"
                :title="'Tanggal Transfer'"
                :keterangan="keteranganTanggalTransfer"
                v-if="filterSetting.tanggalTransfer"
            />
            <SOFilterJenisMember
                :id="'filter-jenis-member'"
                v-if="filterSetting.idmaster_member"
            />
          </div>

          <div class="nav-bottom-wrapper">
            <div class="p-x-20 d-flex-between-center w-limit">
              <button class="btn btn-outline-primary btn-long m-r-12" @click="resetFilter">
                Reset
              </button>
              <button class="btn btn-primary btn-long" @click="doFilter">
                Terapkan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SOFilterSortingV2 from "@/so-components/global/filter/type/SOFilterSortingV2";
import SOFilterPeriode from "@/so-components/global/filter/type/SOFilterPeriode";
import SOFilterAgama from "@/so-components/global/filter/type/SOFilterAgama";
import SOFilterStatusOutlet from "@/so-components/global/filter/type/SOFilterStatusOutlet";
import SOFilterKota from "@/so-components/global/filter/type/SOFilterKota";
import SOFilterOutlet from "@/so-components/global/filter/type/SOFilterOutlet";
import SOFilterWorkshop from "@/so-components/global/filter/type/SOFilterWorkshop";
import SOFilterSettlementAkun from "@/so-components/global/filter/type/SOFilterSettlementAkun";
import SOFilterProviderEdc from "@/so-components/global/filter/type/SOFilterProviderEdc";
import SOFilterPaketDeposit from "@/so-components/global/filter/type/SOFilterPaketDeposit";
import SOFilterPaketEpayment from "@/so-components/global/filter/type/SOFilterPaketEpayment";
import SOFilterStatusLayanan from "@/so-components/global/filter/type/SOFilterStatusLayanan";
import SOFilterJenisLayananSnapclean from "@/so-components/global/filter/type/SOFilterJenisLayananSnapclean";
import SOFilterJenisLayananReguler from "@/so-components/global/filter/type/SOFilterJenisLayananReguler";
import SOFilterJenisMesinSnapclean from "@/so-components/global/filter/type/SOFilterJenisMesinSnapclean";
import SOFilterJenisTransaksi from "@/so-components/global/filter/type/SOFilterJenisTransaksi";
import SOFilterTipePembayaran from "@/so-components/global/filter/type/SOFilterTipePembayaran";
import SOFilterJenisPembayaran from "@/so-components/global/filter/type/SOFilterJenisPembayaran";
import SOFilterJenisPembayaranSnapclean from "@/so-components/global/filter/type/SOFilterJenisPembayaranSnapclean";
import SOFilterSatuan from "@/so-components/global/filter/type/SOFilterSatuan";
import SOFilterKategoriLayanan from "@/so-components/global/filter/type/SOFilterKategoriLayanan";
import SOFilterKategoriMesin from "@/so-components/global/filter/type/SOFilterKategoriMesin";
import SOFilterKategoriRak from "@/so-components/global/filter/type/SOFilterKategoriRak";
import SOFilterLayananTerhubung from "@/so-components/global/filter/type/SOFilterLayananTerhubung";
import SOFilterLayananOwner from "@/so-components/global/filter/type/SOFilterLayananOwner";
import SOFilterLayananSnapcleanOwner from "@/so-components/global/filter/type/SOFilterLayananSnapcleanOwner";
import SOFilterMasaAktif from "@/so-components/global/filter/type/SOFilterMasaAktif";
import SOFilterBonusEpayment from "@/so-components/global/filter/type/SOFilterBonusEpayment";
import SOFilterStatusWorkshop from "@/so-components/global/filter/type/SOFilterStatusWorkshop";
import SOFilterStatusKaryawan from "@/so-components/global/filter/type/SOFilterStatusKaryawan";
import SOFilterStatusAbsen from "@/so-components/global/filter/type/SOFilterStatusAbsen";
import SOFilterSumberAbsen from "@/so-components/global/filter/type/SOFilterSumberAbsen";
import SOFilterStatusGaji from "@/so-components/global/filter/type/SOFilterStatusGaji";
import SOFilterStatusTanggungan from "@/so-components/global/filter/type/SOFilterStatusTanggungan";
import SOFilterStatusPembayaran from "@/so-components/global/filter/type/SOFilterStatusPembayaran";
import SOFilterStatusTransaksi from "@/so-components/global/filter/type/SOFilterStatusTransaksi";
import SOFilterStatusTransaksiSnapclean from "@/so-components/global/filter/type/SOFilterStatusTransaksiSnapclean";
import SOFilterNotaDihitung from "@/so-components/global/filter/type/SOFilterNotaDihitung";
import SOFilterKontakKonsumen from "@/so-components/global/filter/type/SOFilterKontakKonsumen";
import SOFilterStatusKonfirmasi from "@/so-components/global/filter/type/SOFilterStatusKonfirmasi";
import SOFilterAkunKeuanganGlobal from "@/so-components/global/filter/type/SOFilterAkunKeuanganGlobal";
import SOFilterAkunBiayaItemBiaya from "@/so-components/global/filter/type/SOFilterAkunBiayaItemBiaya";
import SOFilterDataKonsumen from "@/so-components/global/filter/type/SOFilterDataKonsumen";
import SOFilterKaryawan from "@/so-components/global/filter/type/SOFilterKaryawan";
import SOFilterMesinSnap from "@/so-components/global/filter/type/SOFilterMesinSnap";
import SOFilterOwner from "@/so-components/global/filter/type/SOFilterOwner";

import SOFilterOutletNonaktif from "@/so-components/global/filter/type/SOFilterOutletNonaktif";
import SOFilterWorkshopNonaktif from "@/so-components/global/filter/type/SOFilterWorkshopNonaktif";
import SOFilterPaketKedaluarsa from "@/so-components/global/filter/type/SOFilterPaketKedaluarsa";

import {mapGetters} from "vuex";
import SOFilterSnapConsole from "@/so-components/global/filter/type/SOFilterSnapConsole";
import SOFilterStatusKoneksi from "@/so-components/global/filter/type/SOFilterStatusKoneksi";
import SOFilterStatuspMesin from "@/so-components/global/filter/type/SOFilterStatusMesin";
import SOFilterStatusMesinEdc from "@/so-components/global/filter/type/SOFilterStatusMesinEdc";
import SOFilterStatusSensorPintu from "@/so-components/global/filter/type/SOFilterStatusSensorPintu";
import SOFilterJenisMesin from "@/so-components/global/filter/type/SOFilterJenisMesin";

import SOFilterRekeningAtasNama from "@/so-components/global/filter/type/SOFilterRekeningAtasNama";
import SOFilterJenisTransaksiRiwayatTransfer from "@/so-components/global/filter/type/SOFilterJenisTransaksiRiwayatTransfer";
import SOFilterTanggalTransfer from "@/so-components/global/filter/type/SOFilterTanggalTransfer";
import SOFilterSaldoEPayment from "@/so-components/global/filter/type/SOFilterSaldoEPayment";
import SOFilterJenisMember from "@/so-components/global/filter/type/SOFilterJenisMember";
import SOFilterStatusDeposit from "@/so-components/global/filter/type/SOFilterStatusDeposit.vue";
import SOFilterJenisKonsumen from "@/so-components/global/filter/type/SOFilterJenisKonsumen.vue";
import SOFilterMetodeTopup from "@/so-components/global/filter/type/SOFilterMetodeTopup.vue";

export default {
  name: "SOFilter",
  components: {
    SOFilterMetodeTopup,
    SOFilterJenisKonsumen,
    SOFilterJenisMesin,
    SOFilterStatusSensorPintu,
    SOFilterStatuspMesin,
    SOFilterStatusKoneksi,
    SOFilterSnapConsole,
    SOFilterSortingV2,
    SOFilterPeriode,
    SOFilterAgama,
    SOFilterStatusOutlet,
    SOFilterKota,
    SOFilterOutlet,
    SOFilterWorkshop,
    SOFilterSettlementAkun,
    SOFilterProviderEdc,
    SOFilterStatusMesinEdc,
    SOFilterPaketDeposit,
    SOFilterStatusDeposit,
    SOFilterPaketEpayment,
    SOFilterStatusLayanan,
    SOFilterJenisLayananSnapclean,
    SOFilterJenisLayananReguler,
    SOFilterJenisMesinSnapclean,
    SOFilterJenisTransaksi,
    SOFilterTipePembayaran,
    SOFilterJenisPembayaran,
    SOFilterJenisPembayaranSnapclean,
    SOFilterSatuan,
    SOFilterKategoriLayanan,
    SOFilterKategoriMesin,
    SOFilterKategoriRak,
    SOFilterLayananTerhubung,
    SOFilterLayananOwner,
    SOFilterLayananSnapcleanOwner,
    SOFilterMasaAktif,
    SOFilterBonusEpayment,
    SOFilterStatusWorkshop,
    SOFilterStatusKaryawan,
    SOFilterStatusAbsen,
    SOFilterSumberAbsen,
    SOFilterStatusGaji,
    SOFilterStatusTanggungan,
    SOFilterStatusPembayaran,
    SOFilterStatusTransaksi,
    SOFilterStatusTransaksiSnapclean,
    SOFilterNotaDihitung,
    SOFilterKontakKonsumen,
    SOFilterStatusKonfirmasi,
    SOFilterAkunKeuanganGlobal,
    SOFilterAkunBiayaItemBiaya,
    SOFilterDataKonsumen,
    SOFilterKaryawan,
    SOFilterMesinSnap,
    SOFilterOwner,

    SOFilterOutletNonaktif,
    SOFilterWorkshopNonaktif,
    SOFilterPaketKedaluarsa,

    SOFilterRekeningAtasNama,
    SOFilterJenisTransaksiRiwayatTransfer,
    SOFilterTanggalTransfer,
    SOFilterSaldoEPayment,
    SOFilterJenisMember,
  },
  computed: {
    ...mapGetters("filterGlobalModule", {
      filterItem: "getFilterItem",
      filterSetting: "getFilterSetting",
    })
  },
  props: {
    sorting: Array,

    filterKonsumen: Boolean,
    filterKonsumenSnapclean: Boolean,
    filterTransaksiKonsumen: Boolean,
    filterTransaksiSnapcleanKonsumen: Boolean,
    filterPaketDepositKonsumen: Boolean,
    filterPenghapusanTransaksi: Object,
    filterPaketDeposit: Boolean,
    filterPaketEpayment: Boolean,
    filterMesinEdc: Boolean,
    filterPesanWhatsapp: Boolean,
    filterSettlementEdc: Boolean,
    filterRekeningBank: Boolean,
    filterRiwayatTransferBank: Boolean,
    filterSettlementGlobal: Boolean,
    filterSetoranKasOutlet: Boolean,
    filterSetoranKasWorkshop: Boolean,
    filterPermintaanKasOutlet: Boolean,
    filterPermintaanKasWorkshop: Boolean,
    filterBiayaOutlet: Boolean,
    filterBiayaWorkshop: Boolean,
    filterWaStatus: {
      type: String,
      default: ""
    },

    //outlet
    filterJenisSnapConsole: Boolean,
    filterSnapMesin: Boolean,

    //Owner Afiliasi
    ownerAfiliated: {
      type: Array,
      default: function () {
        return []
      }
    },

    idcustomer: String
  },
  data() {
    return {
      setDefaultSortingCalled: false,
      sortByColumn: {
        nama: "",
        absensi: "",
        harga: "",
        gaji: "",
        banyakTransaksiKonsumen: "",
        transaksiKonsumen: "",
        nominalTransaksi: "",
      },
      checkAll: {
        outlet: false,
        workshop: false,
        deposit: false,
        epayment: false,
        akunSettlement: false,
      },
      customTitle: {
        outlet: "Outlet",
        workshop: "",
        akunSettlement: "",
        providerEdc: "",
        jenisLayananSnapclean: "",
        jenisLayananReguler: "",
        paketDeposit: "",
        paketEpayment: "",
        dataKonsumen: "",
        karyawan: "",
        mesinSnap: "",
        periode: "",
        layananOwner: "",
        akunKeuanganGlobal: "",
        akunBiayaItemBiaya: "",
        statusKonfirmasi: "",
      },
      jensiPeriode: {
        transaksi: false
      },
      optionData: {
        periode: {
          data: [],
          selected: "",
          filterGlobalKey: "",
        },
        layananOwner: {
          data: [],
          selected: "",
          filterGlobalKey: "",
        },
        layananSnapcleanOwner: {
          data: [],
          selected: "",
          filterGlobalKey: "",
        }
      },
      keteranganPeriode: "",
      filterItemCopy: {},
      keteranganTanggalTransfer: ""
    }
  },
  mounted() {
    this.setFilter();
    $("#modal-filter").modal("show");
    this.filterItemCopy = JSON.parse(JSON.stringify(this.filterItem))
  },
  methods: {
    clearProp() {
      this.filterKonsumen = false
      this.filterTransaksiKonsumen = false
      this.filterTransaksiSnapcleanKonsumen = false
      this.filterPaketDepositKonsumen = false
      this.filterPenghapusanTransaksi = {}
    },

    showFilterOutlet() {
      this.resetFilter()
      this.filterSetting.outletNonaktif = true;
      this.filterSetting.sorting.show = true;
      this.filterSetting.statusOutlet = true;
      this.filterSetting.kota = true;
    },
    showFilterLayananReguler() {
      this.resetFilter()
      this.filterSetting.sorting.show = true;
      this.filterSetting.statusLayanan = true;
      this.filterSetting.satuan = true;
      this.filterSetting.kategoriLayanan = true;
    },
    showFilterKonsumen() {
      var temp = this.filterSetting
      temp.periode = true
      temp.sorting.show = true;
      temp.kontakKonsumen = true;
      temp.layananOwner = true
      temp.deposit = true
      temp.outlet = true
      temp.filterSaldoEpayment = true
      temp.agama = true
      temp.statusDeposit = true
      temp.idmaster_member = true
      temp.jenisKonsumen = true
      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterKonsumenSnapclean() {
      var temp = this.filterSetting
      temp.sorting.show = true;
      temp.periode = true
      temp.layananSnapcleanOwner = true
      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterTransaksiKonsumen() {
      var temp = this.filterSetting
      temp.sorting.show = true;

      temp.periode = true
      temp.outlet = true
      temp.jenisTransaksi = true
      temp.tipePembayaran = true
      temp.jenisPembayaran = true
      temp.karyawan = true
      // temp.mesinSnap = true
      temp.statusPembayaran = true
      temp.statusTransaksi = true
      temp.mesinSnap = true
      temp.layananOwner = true

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterTransaksiSnapcleanKonsumen() {
      var temp = this.filterSetting
      temp.sorting.show = true;

      temp.periode = true
      temp.outlet = true
      temp.jenisLayananSnapclean = true
      temp.jenisPembayaranSnapclean = true
      temp.statusPembayaran = true
      temp.statusTransaksiSnapclean = true
      temp.mesinSnap = true

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },

    showFilterPaketDepositKonsumen() {
      var temp = this.filterSetting
      temp.sorting.show = true;

      temp.layananTerhubung = true;
      temp.masaAktif = true
      temp.paketKedaluarsa = true

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterPenghapusanTransaksiReguler() {
      let temp = this.filterSetting
      temp.sorting.show = true;

      temp.outlet = true;
      temp.statusKonfirmasi = true;
      temp.jenisLayananReguler = true;
      this.$store.commit("filterGlobalModule/setFilterSetting", temp);
    },
    showFilterPenghapusanTopupDeposit() {
      let temp = this.filterSetting
      temp.sorting.show = true;

      temp.outlet = true;
      temp.statusKonfirmasi = true;
      temp.deposit = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp);
    },
    showFilterPenghapusanTopupEpayment() {
      let temp = this.filterSetting
      temp.sorting.show = true;

      temp.outlet = true;
      temp.statusKonfirmasi = true;
      temp.epayment = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp);
    },
    showFilterPenghapusanSnapclean() {
      let temp = this.filterSetting
      temp.sorting.show = true;

      temp.outlet = true;
      temp.statusKonfirmasi = true;
      // temp.jenisLayananSnapclean = true;
      // temp.dataKonsumen = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp);
    },
    showFilterPaketDeposit() {
      var temp = this.filterSetting
      temp.sorting.show = true;

      temp.periode = true;
      temp.outlet = true;
      temp.deposit = true
      temp.karyawan = true

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterJenisSnapConsole() {
      var temp = this.filterSetting
      temp.jenisSnapConsole = true

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterSnapMesin() {
      var temp = this.filterSetting
      temp.sorting.show = true
      temp.statusKoneksi = true
      temp.statusMesin = true
      temp.statusSensorPintu = true
      temp.kategoriMesin = true
      temp.jenisMesin = true

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },

    showFilterPaketEpayment() {
      var temp = this.filterSetting
      temp.sorting.show = true;

      temp.periode = true;
      temp.outlet = true;
      temp.epayment = true
      temp.karyawan = true
      temp.metodeTopup = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },

    showFilterOwnerAfiliated() {
      let temp = this.filterSetting;

      temp.afiliasiOwner = true;
      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterRekeningBank() {
      var temp = this.filterSetting
      temp.sorting.show = true;
      temp.rekeningAtasNama = true

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterRiwayatTransferBank() {
      var temp = this.filterSetting
      temp.jenisTransaksiRiwayatTransfer = true
      temp.tanggalTransfer = true
      this.keteranganTanggalTransfer = "Anda hanya dapat memilih rentang periode maksimal 30 hari."

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },

    showFilterMesinEdc() {
      let temp = this.filterSetting;
      temp.sorting.show = true;
      temp.periode = true;
      temp.outlet = true;
      temp.statusMesinEdc = true;
      temp.akunSettlement = true;
      temp.providerEdc = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterPesanWhatsapp() {
      let temp = this.filterSetting;
      temp.sorting.show = true;
      temp.periode = true;
      temp.statusKonfirmasi = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterWaStatus() {
      let temp = this.filterSetting;
      temp.sorting.show = true;
      temp.statusKonfirmasi = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterSettlementGlobal() {
      let temp = this.filterSetting;
      temp.sorting.show = true;
      temp.periode = true;
      temp.outlet = true;
      temp.akunSettlement = true;
      temp.providerEdc = true;
      temp.statusKonfirmasi = true;
      temp.karyawan = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },

    showFilterSettlementEdc() {
      let temp = this.filterSetting;
      temp.sorting.show = true;
      temp.periode = true;
      temp.statusKonfirmasi = true;
      temp.akunSettlement = true;
      temp.karyawan = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },

    showFilterSetoranKasOutlet() {
      let temp = this.filterSetting;
      temp.sorting.show = true;
      temp.periode = true;
      temp.statusKonfirmasi = true;
      temp.outlet = true;
      temp.akunKeuanganGlobal = true;
      temp.karyawan = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterSetoranKasWorkshop() {
      let temp = this.filterSetting;
      temp.sorting.show = true;
      temp.periode = true;
      temp.statusKonfirmasi = true;
      temp.workshop = true;
      temp.akunKeuanganGlobal = true;
      temp.karyawan = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterPermintaanKasOutlet() {
      let temp = this.filterSetting;
      temp.sorting.show = true;
      temp.periode = true;
      temp.statusKonfirmasi = true;
      temp.outlet = true;
      temp.akunKeuanganGlobal = true;
      temp.karyawan = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterPermintaanKasWorkshop() {
      let temp = this.filterSetting;
      temp.sorting.show = true;
      temp.periode = true;
      temp.statusKonfirmasi = true;
      temp.workshop = true;
      temp.akunKeuanganGlobal = true;
      temp.karyawan = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterBiayaOutlet() {
      let temp = this.filterSetting;
      temp.sorting.show = true;
      temp.periode = true;
      temp.statusKonfirmasi = true;
      temp.outlet = true;
      temp.akunKeuanganGlobal = true;
      temp.akunBiayaItemBiaya = true;
      temp.karyawan = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },
    showFilterBiayaWorkshop() {
      let temp = this.filterSetting;
      temp.sorting.show = true;
      temp.periode = true;
      temp.statusKonfirmasi = true;
      temp.workshop = true;
      temp.akunKeuanganGlobal = true;
      temp.akunBiayaItemBiaya = true;
      temp.karyawan = true;

      this.$store.commit("filterGlobalModule/setFilterSetting", temp)
    },

    setFilter() {
      if (this.filterKonsumen) {
        this.customTitle.periode = "Rentang Tanggal"
        this.customTitle.paketDeposit = "Memiliki Deposit"
        this.customTitle.layananOwner = "Layanan"
        this.optionData.periode.data = [
          {
            id: "periode_terdaftar",
            text: "Tanggal terdaftar",
          },
          {
            id: "periode_transaksi",
            text: "Tanggal berkunjung",
          },
          {
            id: "periode_tidak_transaksi",
            text: "Tidak pernah berkunjung",
          },
        ]
        this.optionData.periode.selected = this.filterItem.filterRentangTanggalKonsumen === "" ? "periode_terdaftar" : this.filterItem.filterRentangTanggalKonsumen
        this.optionData.periode.filterGlobalKey = "filterRentangTanggalKonsumen"

        this.optionData.layananOwner.data = [
          {
            id: "transaksi_semua_layanan",
            text: "Pernah transaksi dg semua layanan",
          },
          {
            id: "transaksi_salah_satu_layanan",
            text: "Pernah transaksi dg semua/salah satu layanan",
          },
          {
            id: "transaksi_tanpa_layanan",
            text: "Tidak pernah transaksi dg layanan",
          },
        ]
        this.optionData.layananOwner.selected = this.filterItem.filterLayananOwner === "" ? "transaksi_semua_layanan" : this.filterItem.filterLayananOwner
        this.optionData.layananOwner.filterGlobalKey = "filterLayananOwner"
        this.showFilterKonsumen()
      }
      if (this.filterKonsumenSnapclean) {
        this.customTitle.periode = "Rentang Tanggal"
        this.optionData.periode.data = [
          {
            id: "periode_terdaftar",
            text: "Tanggal terdaftar",
          },
          {
            id: "periode_transaksi",
            text: "Tanggal berkunjung",
          },
          {
            id: "periode_tidak_transaksi",
            text: "Tidak pernah berkunjung",
          },
        ]
        this.optionData.periode.selected = this.filterItem.filterRentangTanggalKonsumenSnapclean === "" ? "periode_terdaftar" : this.filterItem.filterRentangTanggalKonsumenSnapclean
        this.optionData.periode.filterGlobalKey = "filterRentangTanggalKonsumenSnapclean"

        this.optionData.layananSnapcleanOwner.data = [
          {
            id: "transaksi_semua_layanan",
            text: "Pernah transaksi dg semua layanan",
          },
          {
            id: "transaksi_salah_satu_layanan",
            text: "Pernah transaksi dg semua/salah satu layanan",
          },
          {
            id: "transaksi_tanpa_layanan",
            text: "Tidak pernah transaksi dg layanan",
          },
        ]
        this.optionData.layananSnapcleanOwner.selected = this.filterItem.filterLayananSnapcleanOwner === "" ? "transaksi_semua_layanan" : this.filterItem.filterLayananSnapcleanOwner
        this.optionData.layananSnapcleanOwner.filterGlobalKey = "filterLayananSnapcleanOwner"
        this.showFilterKonsumenSnapclean()
      }
      if (this.filterTransaksiKonsumen) {
        this.customTitle.outlet = "Transaksi di Outlet"
        this.customTitle.karyawan = "Pembuat Nota"
        this.customTitle.mesinSnap = "Mesin Yang Digunakan"
        this.customTitle.periode = "Periode"
        this.customTitle.layananOwner = "Transaksi Dengan Layanan"
        this.checkAll.outlet = true
        this.jensiPeriode.transaksi = true
        this.optionData.periode.data = [
          {
            id: "pembuatan_nota",
            text: "Tanggal Pembuatan Nota",
          },
          {
            id: "harus_selesai",
            text: "Tanggal Harus Selesai",
          },
          {
            id: "harus_diantar",
            text: "Tanggal Harus Diantar",
          },
          {
            id: "pembayaran",
            text: "Tanggal Pembayaran",
          },
          {
            id: "pengambilan",
            text: "Tanggal Pengambilan",
          },
        ]
        this.optionData.periode.selected = this.filterItem.filterKolomTransaksi === '' ? 'pembuatan_nota' : this.filterItem.filterKolomTransaksi
        this.optionData.periode.filterGlobalKey = "filterKolomTransaksi"
        this.showFilterTransaksiKonsumen()
      }
      if (this.filterTransaksiSnapcleanKonsumen) {
        this.customTitle.outlet = "Transaksi di Outlet"
        this.customTitle.jenisLayananSnapclean = "Jenis Transaksi"
        this.checkAll.outlet = true
        this.keteranganPeriode = "Periode berdasarkan tanggal pembuatan nota"
        this.customTitle.periode = "Periode"
        this.customTitle.mesinSnap = "Mesin Yang Digunakan"
        this.showFilterTransaksiSnapcleanKonsumen()
      }
      if (this.filterPenghapusanTransaksi !== undefined && Object.keys(this.filterPenghapusanTransaksi).length > 0) {
        if (this.filterPenghapusanTransaksi.deposit) {
          this.customTitle.jenisLayananReguler = "Jenis Transaksi"
          this.customTitle.outlet = "Transaksi di Outlet"
          this.customTitle.paketDeposit = "Paket Deposit"
          this.checkAll.outlet = true;
          this.checkAll.deposit = true;
          this.showFilterPenghapusanTopupDeposit()
        }
        if (this.filterPenghapusanTransaksi.reguler) {
          this.checkAll.outlet = true;
          this.customTitle.jenisLayananReguler = "Jenis Transaksi"
          this.showFilterPenghapusanTransaksiReguler()
        }
        if (this.filterPenghapusanTransaksi.ePayment) {
          this.checkAll.outlet = true;
          this.checkAll.epayment = true;
          this.customTitle.paketEpayment = "Paket E-Payment"
          this.customTitle.jenisLayananReguler = "Jenis Transaksi"
          this.showFilterPenghapusanTopupEpayment()
        }
        if (this.filterPenghapusanTransaksi.snapclean) {
          this.checkAll.outlet = true;
          // this.customTitle.jenisLayananSnapclean = "Jenis Transaksi";
          // this.customTitle.dataKonsumen = "Data Konsumen";
          this.showFilterPenghapusanSnapclean();
        }
      }
      if (this.filterPaketDepositKonsumen) this.showFilterPaketDepositKonsumen()
      if (this.filterJenisSnapConsole) this.showFilterJenisSnapConsole()
      if (this.filterSnapMesin) this.showFilterSnapMesin()
      if (this.filterPaketDeposit) {
        this.customTitle.outlet = "Transaksi di Outlet"
        this.customTitle.paketDeposit = "Top Up Paket"
        this.customTitle.karyawan = "Pembuat Nota"
        this.checkAll.outlet = true
        this.checkAll.deposit = true
        this.showFilterPaketDeposit()
      }
      if (this.filterPaketEpayment) {
        this.customTitle.outlet = "Transaksi di Outlet"
        this.customTitle.paketEpayment = "Top Up Paket"
        this.customTitle.karyawan = "Pembuat Nota"
        this.checkAll.outlet = true
        this.checkAll.epayment = true
        this.showFilterPaketEpayment()
      }
      if (this.ownerAfiliated.length > 0) {
        this.showFilterOwnerAfiliated();
      }

      if (this.filterMesinEdc) {
        this.customTitle.periode = "Tanggal Settlement"
        this.showFilterMesinEdc();
      }

      if (this.filterPesanWhatsapp) {
        this.customTitle.periode = "Tanggal pengiriman";
        this.customTitle.statusKonfirmasi = "Status pesan";
        this.showFilterPesanWhatsapp();
        setTimeout(() => {
          this.$refs.filterStatusKonfirmasi.checkList.data[0].title = "Terkirim";
          this.$refs.filterStatusKonfirmasi.checkList.data[0].value = "3";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].title = "Sedang dalam antrian";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].value = "2";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].title = "Gagal";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].value = "4";
        }, 100);
      }

      if (this.filterWaStatus === "aktif") {
        this.customTitle.statusKonfirmasi = "Tipe postingan";
        this.showFilterWaStatus();
        setTimeout(() => {
          this.$refs.filterStatusKonfirmasi.checkList.data[0].title = "Berulang";
          this.$refs.filterStatusKonfirmasi.checkList.data[0].value = "1";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].title = "Dijadwalkan";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].value = "0";
          this.$refs.filterStatusKonfirmasi.checkList.data.pop();
        }, 100);
      }
      if (this.filterWaStatus === "riwayat") {
        this.customTitle.statusKonfirmasi = "Status postingan";
        this.showFilterWaStatus();
        setTimeout(() => {
          this.$refs.filterStatusKonfirmasi.checkList.data[0].title = "Telah diposting";
          this.$refs.filterStatusKonfirmasi.checkList.data[0].value = "2";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].title = "Telah diakhiri";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].value = "4";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].title = "Gagal";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].value = "3";
          this.$refs.filterStatusKonfirmasi.checkList.data.push({
            title: "Tidak aktif",
            value: "0"
          });
        }, 100);
      }

      if (this.filterSettlementEdc) {
        this.customTitle.periode = "Tanggal Settlement"
        this.customTitle.karyawan = "Pembuat setoran"
        this.showFilterSettlementEdc();
        setTimeout(() => {
          this.$refs.filterStatusKonfirmasi.checkList.data[1].title = "Disetujui";
        }, 100);
      }

      if (this.filterRekeningBank) {
        this.showFilterRekeningBank()
      }
      if (this.filterRiwayatTransferBank) {
        this.showFilterRiwayatTransferBank()
      }
      if (this.filterSettlementGlobal) {
        this.customTitle.periode = "Tanggal Settlement"
        this.customTitle.akunSettlement = "Disetor ke akun"
        this.customTitle.karyawan = "Pembuat Settlement"
        setTimeout(() => {
          this.$refs.filterStatusKonfirmasi.checkList.data[1].title = "Disetujui";
        }, 100);
        this.showFilterSettlementGlobal();
      }

      if (this.filterSetoranKasOutlet) {
        this.customTitle.periode = "Tanggal setoran"
        this.customTitle.akunKeuanganGlobal = "Akun tujuan setor"
        this.customTitle.karyawan = "Pembuat setoran"
        this.customTitle.statusKonfirmasi = "Status Konfirmasi";
        this.showFilterSetoranKasOutlet();
        setTimeout(() => {
          this.$refs.filterStatusKonfirmasi.checkList.data[0].title = "Belum dikonfirmasi";
          this.$refs.filterStatusKonfirmasi.checkList.data[0].value = "1";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].title = "Disetujui";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].value = "2";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].title = "Ditolak";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].value = "3";
        }, 500);
      }
      if (this.filterSetoranKasWorkshop) {
        this.customTitle.periode = "Tanggal setoran"
        this.customTitle.akunKeuanganGlobal = "Akun tujuan setor"
        this.customTitle.karyawan = "Pembuat setoran"
        this.customTitle.statusKonfirmasi = "Status Konfirmasi";
        this.showFilterSetoranKasWorkshop();
        setTimeout(() => {
          this.$refs.filterStatusKonfirmasi.checkList.data[0].title = "Belum dikonfirmasi";
          this.$refs.filterStatusKonfirmasi.checkList.data[0].value = "1";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].title = "Disetujui";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].value = "2";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].title = "Ditolak";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].value = "3";
        }, 500);
      }
      if (this.filterPermintaanKasOutlet) {
        this.customTitle.periode = "Tanggal permintaan"
        this.customTitle.akunKeuanganGlobal = "Dari akun kas"
        this.customTitle.karyawan = "Diminta oleh"
        this.customTitle.statusKonfirmasi = "Status Konfirmasi";
        this.showFilterPermintaanKasOutlet();
        setTimeout(() => {
          this.$refs.filterStatusKonfirmasi.checkList.data[0].title = "Belum dikonfirmasi";
          this.$refs.filterStatusKonfirmasi.checkList.data[0].value = "1";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].title = "Disetujui";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].value = "2";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].title = "Ditolak";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].value = "3";
        }, 500);
      }
      if (this.filterPermintaanKasWorkshop) {
        this.customTitle.periode = "Tanggal permintaan"
        this.customTitle.akunKeuanganGlobal = "Dari akun kas"
        this.customTitle.karyawan = "Diminta oleh"
        this.customTitle.statusKonfirmasi = "Status Konfirmasi";
        this.showFilterPermintaanKasWorkshop();
        setTimeout(() => {
          this.$refs.filterStatusKonfirmasi.checkList.data[0].title = "Belum dikonfirmasi";
          this.$refs.filterStatusKonfirmasi.checkList.data[0].value = "1";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].title = "Disetujui";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].value = "2";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].title = "Ditolak";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].value = "3";
        }, 500);
      }
      if (this.filterBiayaOutlet) {
        this.customTitle.periode = "Tanggal permintaan biaya"
        this.customTitle.akunKeuanganGlobal = "Biaya dari akun"
        this.customTitle.akunBiayaItemBiaya = "Akun biaya yang digunakan",
            this.customTitle.karyawan = "Diminta oleh"
        this.customTitle.statusKonfirmasi = "Status Konfirmasi";
        this.showFilterBiayaOutlet();
        setTimeout(() => {
          this.$refs.filterStatusKonfirmasi.checkList.data[0].title = "Belum dikonfirmasi";
          this.$refs.filterStatusKonfirmasi.checkList.data[0].value = "1";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].title = "Disetujui";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].value = "2";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].title = "Ditolak";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].value = "3";
        }, 500);
      }
      if (this.filterBiayaWorkshop) {
        this.customTitle.periode = "Tanggal permintaan biaya",
            this.customTitle.akunKeuanganGlobal = "Biaya dari akun",
            this.customTitle.akunBiayaItemBiaya = "Akun biaya yang digunakan",
            this.customTitle.karyawan = "Diminta oleh"
        this.customTitle.statusKonfirmasi = "Status Konfirmasi";
        this.showFilterBiayaWorkshop();
        setTimeout(() => {
          this.$refs.filterStatusKonfirmasi.checkList.data[0].title = "Belum dikonfirmasi";
          this.$refs.filterStatusKonfirmasi.checkList.data[0].value = "1";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].title = "Disetujui";
          this.$refs.filterStatusKonfirmasi.checkList.data[1].value = "2";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].title = "Ditolak";
          this.$refs.filterStatusKonfirmasi.checkList.data[2].value = "3";
        }, 500);
      }
    },
    back(payload) {
      $("#modal-filter").modal("hide");
      this.$store.commit("filterGlobalModule/setFilterItem", this.filterItemCopy)
      setTimeout(() => {
        this.$emit("back", payload)
      }, 500)
    },
    resetFilter() {
      this.$store.commit("filterGlobalModule/resetFilterItem")
      this.$store.commit("filterGlobalModule/resetFilter")
      this.setFilter()
      this.$emit("reset-filter")
    },
    doFilter(payload) {
      if (!this.saldoValid()) return
      $("#modal-filter").modal("hide");
      this.$router.replace({'query': null});
      this.$emit("do-filter", payload)
    }
  },
  beforeDestroy() {
    this.clearProp();
    this.$store.commit("filterGlobalModule/resetFilterSetting")
  }
}
</script>

<style>
.nav-bottom-wrapper {
  position: sticky;
  left: 0;
  width: 100%;
  bottom: 0px;
  background: white;
  box-shadow: 0px -6px 12px rgba(0, 0, 0, 0.05);
}
</style>